import { ExtFile } from "../types";
import { NO_URL_MESSAGE, NO_XHR_MESSAGE } from "../utils/constants";

export const TIMEOUT_ERROR_RESPONSE = {
    success: false,
    message: "Timeout error",
    payload: {}
};
export const ABORTED_ERROR_RESPONSE = {
    success: false,
    message: "Upload aborted",
    payload: {}
}
export const JSON_PARSE_ERROR_RESPONSE = {
    success: false,
    message: "Error when parsing JSON response",
    payload: {}
}

export const UNEXPECTED_ERROR_RESPONSE = {
    success: false,
    message: "Unexpected error",
    payload: {}
}

export const NO_XHR_PROVIDED_ERROR = (extFile: ExtFile): ExtFile => {
    return {
        ...extFile,
        uploadMessage: NO_XHR_MESSAGE,
        uploadStatus: "error",
        serverResponse: { success: false, }
    }
}


export const NO_URL_PROVIDED_ERROR = (extFile: ExtFile): ExtFile => {
    return {
        ...extFile,
        uploadMessage: NO_URL_MESSAGE ,
        uploadStatus: "error",
        serverResponse: { success: false, }
    }
}